<template>
  <div class="user-auth-state">
    <z-fix-top
      keep-position
      class="fixtop"
    >
      <z-nav-bar
          class="navbar"
          left-arrow
          :title="navtitle"
          @click-left="closePage"
      >
      </z-nav-bar>
    </z-fix-top>
    <section class="cell" v-show="hasVerified && isMe">
      <z-cell-group inset>
        <z-cell>
          <div class="celltitle" slot="title">认证信息</div>
        </z-cell>
        <z-cell title="本人姓名" @click="changeName" :is-link="isMainlandArea" :value="privateInfo.selfName" extra="去认证" />
        <z-cell title="证件号" :value="privateInfo.selfCardId" extra="去认证"/>
        <z-cell v-show="privateInfo.selfCardPic == '1' && !isOpenHarmony" title="证件照片" @click="supplyCard" :is-link="privateInfo.selfCardPicStatus == '0'" :value="privateInfo.selfCardPicValue" extra="待上传" />
        <z-cell v-show="privateInfo.selfFace == '1' && !isOpenHarmony" title="人像验证" @click="supplyFace" :is-link="privateInfo.selfFaceStatus == '0'" :value="privateInfo.selfFaceValue" extra="待验证" />
      </z-cell-group>
     <z-cell-group inset>
      <z-cell v-show="privateInfo?.businessInfoStatus == '1'" title="经营信息" @click="changeBusinessInfo" :is-link="true" extra="待上传" :value="privateInfo.businessInfoValue" title-class="title"/>
     </z-cell-group>
      <z-cell-group inset v-show="privateInfo.guardian == '1'">
        <z-cell :extra="privateInfo.guardianStatusExtra" @click="parentVerify" :is-link="privateInfo.guardianStatus == '0'">
          <div class="celltitle" slot="title">监护人信息</div>
        </z-cell>
        <z-cell v-show="privateInfo.guardianStatus == '1'" title="监护人姓名" :value="privateInfo.guardianName" />
        <z-cell v-show="privateInfo.guardianStatus == '1'" title="证件号" :value="privateInfo.guardianCard"/>
      </z-cell-group>
    </section>
    <section class="notcell" v-show="!hasVerified || !isMe">
      <img v-if="hasVerified && !isMe"
        :src="$setPicSize(successImg)" />
      <img v-if="!hasVerified"
          :src="$setPicSize(failImg)" />
      <div class="result-info">
        <header v-if="isMe && !hasVerified">你尚未实人认证</header>
        <header v-if="isMe && hasVerified">你已完成实人认证</header>
        <header v-if="!isMe && !hasVerified">TA尚未实人认证</header>
        <header v-if="!isMe && hasVerified">TA已完成实人认证</header>
        <div v-else>
          <div v-if="isMe && !hasVerified"
              class="desc">{{msg}}</div>
          <div v-if="!isMe && !hasVerified"
              class="desc">{{msg}}</div>
        </div>
      </div>
      <div class="operation-area">
        <div v-if="isMe && !hasVerified">
          <z-button type="primary" @click="goVerify">去认证</z-button>
        </div>
      </div>
        <z-button-group>
          <div v-show="isMe && !hasVerified" class="another" @click="show">其他认证方式</div>
        </z-button-group>
    </section>

    <z-actionsheet
      title="更改认证方式"
      v-model="showModal"
      :actions="actions"
      cancel-text="取消"
      @select="onSelect"
    />
  </div>
</template>

<script>
import native from '@zz-common/native-adapter';
import { lego } from '@zz-common/lego'
import { FixTop, NavBar, Button, Actionsheet, Cell, CellGroup, ButtonGroup } from '@zz-common/zz-ui'
import { queryParams, compareVersion, getCookie } from '../../lib/utils'
import { env, setPicSize } from '@zz-common/zz-utils'
import { getPrivateInfo } from '@api/resourceApi';

const query = queryParams();

export default {
  name: 'StateComp',
  data() {
    // 获取Cookie中的t值判断是否为奢竞界APP
    const tValue = getCookie('t')
    const isSJJ = tValue === '243' || tValue === '244'
    return {
      from: query.from || this.$route.query.from,
      strategyid: query.strategyid || this.$route.query.strategyid,
      isme: query.isme || this.$route.query.isme,
      verified: query.verified || this.$route.query.verified,
      isSJJ, // 奢竞界APP
      // 根据不同APP显示对应的品牌名称：奢竞界、转转、找靓机
      msg: `实人认证是由${isSJJ ? '奢竞界' : (native.in('zz') ? '转转' : '找靓机')}合作的第三方（腾讯云）使用全球领先的人脸识别技术实现对您身份的有效核定。`,
      successImg: require('./images/auth_success.png'),
      failImg: require('./images/auth_fail.png'),
      businessInfo: {
        0: '',
        1: '个人声明',
        2: '资质证照'
      },
      actions: [
        { name: '中华人民共和国居民身份证', value: '0' },
        { name: '中华人民共和国港澳台居民居住证', value: '1' },
        { name: '港澳居民来往内地通行证', value: '2' },
        { name: '台湾居民来往大陆通行证', value: '3' }
      ],
      showModal: false,
      privateInfo: {}
    }
  },
  computed: {
    isOpenHarmony() { // 是否为鸿蒙且版本号大于10.30.10
      return env.$isOpenHarmony && !compareVersion(getCookie('v') || '', '10.30.10')
    },
    isMe() {
      return this.isme && this.isme != '0';
    },
    hasVerified() {
      return this.verified && this.verified != '0';
    },
    navtitle() {
      if (this.isMe && this.hasVerified) {
        return '身份认证'
      } else {
        return '实人认证'
      }
    },
    //大陆区域
    isMainlandArea() {
      return this.privateInfo.selfCardPicType == '0'
    }
  },
  methods: {
    $setPicSize(url) {
      return setPicSize(url)
    },
    goVerify() {
      lego.send({
        pagetype: 'auth_privateinfo',
        actiontype: 'click_verify',
        backup: {
          sourcecode: this.from,
          version: getCookie('v'),
          app: native.in('zz') ? 'zz' : 'zlj',
          isme: this.isMe,
          verified: this.hasVerified
        }
      })
      //鸿蒙系统且版本小于10.30.10统一跳转二要素
      if (this.isOpenHarmony) {
        native.skipToUrl({
          targetUrl: 'https://m.zhuanzhuan.com/platform/zz-universal-pages/index.html#/IdCardAuth/CommitInfo?sourcecode=selfmain_page',
          needClose: '1'
        })
        return
      }
      if (native.in('zz')) {
        if (compareVersion(getCookie('v') || '', '10.4.0')) {
          native.skipToUrl({
            targetUrl: `https://m.zhuanzhuan.com/platform/zz-universal-pages/index.html#/realauth/verifyface?sourcecode=${this.from}`,
            needClose: '1'
          })
        } else {
          native.skipToUrl({
            targetUrl: 'https://m.zhuanzhuan.com/platform/zz-universal-pages/index.html#/IdCardAuth/CommitInfo?sourcecode=selfmain_page',
            needClose: '1'
          })
        }
      }
      if (native.in('zlj')) {
        native.skipToUrl({
          // targetUrl: `https://m.zhuanzhuan.com/platform/zz-universal-pages/index.html#/zljrealauth/commit?sourcecode=${this.from}`,
          targetUrl: `https://m.zhuanzhuan.com/platform/zz-universal-pages/index.html#/realauth/verifyface?sourcecode=${this.from}`,
          needClose: '1'
        })
      }
      if (this.isSJJ) {
        native.skipToUrl({
          targetUrl: 'https://m.zhuanzhuan.com/platform/zz-universal-pages/index.html#/realauth/verifyface?sourcecode=c2p_selfmain_page',
          needClose: '1'
        })
      }
    },
    closePage() {
      native.close();
    },
    onSelect(val) {
      this.showModal = !this.showModal
      if (val.value == '0') {
        // 根据不同APP使用不同的sourcecode：奢竞界、转转、找靓机
        const sourcecode = this.isSJJ ? 'c2p_selfmain_page' : (native.in('zz') ? 'selfmain_page' : 'zlj_selfmain_page')
        native.skipToUrl({
          targetUrl: `https://m.zhuanzhuan.com/platform/zz-universal-pages/index.html#/IdCardAuth/CommitInfo?sourcecode=${sourcecode}`,
          needClose: '1'
        })
      } else {
        native.skipToUrl({
          targetUrl: `https://m.zhuanzhuan.com/platform/zz-universal-pages/index.html#/newrealauth/commit?authType=${val.value}`,
          needClose: '1'
        })
      }
    },
    show() {
      lego.send({
        pagetype: 'auth_privateinfo',
        actiontype: 'click_other',
        backup: {
          sourcecode: this.from,
          version: getCookie('v'),
          app: native.in('zz') ? 'zz' : 'zlj',
          isme: this.isMe,
          verified: this.hasVerified
        }
      })
      this.showModal = true
    },
    parentVerify() {
      if (this.privateInfo.guardianStatus == '1') return
      lego.send({
        pagetype: 'auth_privateinfo',
        actiontype: 'click_parent',
        backup: {
          sourcecode: this.from,
          version: getCookie('v'),
          app: native.in('zz') ? 'zz' : 'zlj',
          isme: this.isMe,
          verified: this.hasVerified
        }
      })
      // 根据不同APP使用不同的sourcecode：奢竞界、转转、找靓机
      const sourcecode = this.isSJJ ? 'c2p_selfmain_page' : (native.in('zz') ? 'guardian_page' : 'zlj_guardian_page')
      native.skipToUrl({
        targetUrl: `https://m.zhuanzhuan.com/platform/zz-universal-pages/index.html#/IdCardAuth/CommitInfo?sourcecode=${sourcecode}`,
        needClose: '0'
      })
    },
    changeName() {
      if (!this.isMainlandArea) return
      lego.send({
        pagetype: 'auth_privateinfo',
        actiontype: 'click_changename',
        backup: {
          sourcecode: this.from,
          version: getCookie('v'),
          app: native.in('zz') ? 'zz' : 'zlj',
          isme: this.isMe,
          verified: this.hasVerified
        }
      })
      // 注意这里sourcecode大写
      // 根据不同APP使用不同的sourcecode：奢竞界、转转、找靓机
      const sourceCode = this.isSJJ ? 'c2p_selfmain_page' : (native.in('zz') ? 'selfmain_modify_page' : 'zlj_selfmain_modify_page')
      native.skipToUrl({
        targetUrl: `https://m.zhuanzhuan.com/platform/zz-universal-pages/index.html#/realauth/changename?sourceCode=${sourceCode}`,
        needClose: '0'
      })
    },
    supplyCard() {
      if (this.privateInfo.selfCardPicStatus == '1') return
      lego.send({
        pagetype: 'auth_privateinfo',
        actiontype: 'click_cardsupply',
        backup: {
          sourcecode: this.from,
          version: getCookie('v'),
          app: native.in('zz') ? 'zz' : 'zlj',
          isme: this.isMe,
          verified: this.hasVerified
        }
      })
      // 根据不同APP使用不同的sourcecode：奢竞界、转转、找靓机
      const sourcecode = this.isSJJ ? 'c2p_selfmain_page' : (native.in('zz') ? 'add_card_page' : 'zlj_add_card_page')
      native.skipToUrl({
        targetUrl: `https://m.zhuanzhuan.com/platform/zz-universal-pages/index.html#/privateinfosupply/card?name=${encodeURI(this.privateInfo.selfName)}&authType=${this.privateInfo.selfCardPicType}&sourcecode=${sourcecode}`,
        needClose: '0'
      })
    },
    supplyFace() {
      if (this.privateInfo.selfFaceStatus == '1') return
      lego.send({
        pagetype: 'auth_privateinfo',
        actiontype: 'click_facesupply',
        backup: {
          sourcecode: this.from,
          version: getCookie('v'),
          app: native.in('zz') ? 'zz' : 'zlj',
          isme: this.isMe,
          verified: this.hasVerified
        }
      })

      // 原有逻辑保持不变
      if (native.in('zz')) {
        native.skipToUrl({
          targetUrl: `https://m.zhuanzhuan.com/platform/zz-universal-pages/index.html#/realauth/verifyface?strategyid=${this.privateInfo.selfCardPicType}&sourcecode=add_face_page`,
          needClose: '0'
        })
      }
      if (this.isSJJ) {
        native.skipToUrl({
          targetUrl: 'https://m.zhuanzhuan.com/platform/zz-universal-pages/index.html#/realauth/verifyface?sourcecode=c2p_selfmain_page',
          needClose: '0'
        })
      }
      if (native.in('zlj')) {
        native.skipToUrl({
          targetUrl: `https://m.zhuanzhuan.com/platform/zz-universal-pages/index.html#/realauth/verifyface?sourcecode=${this.from}`,
          needClose: '0'
        })
      }
    },
    changeBusinessInfo() {
      if (this.privateInfo.businessInfo == '0') {
        native.skipToUrl({
          targetUrl: `https://m.zhuanzhuan.com/platform/zz-universal-pages/index.html#/bussinessInfo/entry?from=${this.from}`,
          needClose: '0'
        })
      }
      if (this.privateInfo.businessInfo == '1') {
        native.skipToUrl({
          targetUrl: `https://m.zhuanzhuan.com/platform/zz-universal-pages/index.html#/bussinessInfo/personDeclaration?issubmit=1&from=${this.from}`,
          needClose: '0'
        })
      }
      if (this.privateInfo.businessInfo == '2') {
        native.skipToUrl({
          targetUrl: `https://m.zhuanzhuan.com/platform/zz-universal-pages/index.html#/qualityauth/checkinfo?sourceCode=${this.from}`,
          needClose: '0'
        })
      }
    },
    handleVisiable(e) {
      if (e.target.visibilityState === 'visible') {
        this.initData(false)
      }
    },
    initData(val) {
      if (this.isMe && this.hasVerified) {
        getPrivateInfo({ sourcecode: this.from }).then(res => {
          console.log('看看结果', res)
          this.privateInfo = {
            selfCardPicValue: res.selfCardPicStatus == '1' ? '已上传' : '',
            selfFaceValue: res.selfFaceStatus == '1' ? '已验证' : '',
            guardianStatusExtra: res.guardianStatus == '1' ? '' : '待验证',
            businessInfoValue: this.businessInfo[res.businessInfo],
            ...res
          }
          if (val) {
            lego.send({
              pagetype: 'auth_privateinfo',
              actiontype: 'show',
              backup: {
                sourcecode: this.from,
                version: getCookie('v'),
                app: native.in('zz') ? 'zz' : 'zlj',
                isme: this.isMe,
                verified: this.hasVerified,
                show_cardsupply: res.selfCardPic == '1',
                show_facesupply: res.selfFace == '1',
                show_parent: res.guardian == '1'
              }
            })
          }
        }).catch(err => {
          console.error(err);
          this.verified = '0'
        });
      }
    }
  },
  created() {
    native.wrap('setHeaderVisible')({
      visible: '0'
    })
    this.initData(true)
  },
  mounted() {
    document.addEventListener('visibilitychange', this.handleVisiable)
  },
  destroyed() {
    document.removeEventListener('visibilitychange', this.handleVisiable)
  },
  components: {
    'z-nav-bar': NavBar,
    'z-fix-top': FixTop,
    'z-button': Button,
    'z-actionsheet': Actionsheet,
    'z-cell': Cell,
    'z-cell-group': CellGroup,
    'z-button-group': ButtonGroup
  }
};
</script>

<style lang='less' scoped>
@import "index.less";
</style>
